import React from 'react';
import { FiLock } from 'react-icons/fi';
import { Input, Select, cn } from '../../../components/ui/Kit';

export function Field({ label, children, sensitive = false, required = false, tooltip = null }) {
  return (
    <label className="block">
      <span className="mb-1 inline-flex items-center gap-1 text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500">*</span>}
        {sensitive && <FiLock className="h-3.5 w-3.5 text-gray-400" aria-label="Sensitive" />}
      </span>
      {tooltip ? <p className="mb-1 text-xs text-gray-500">{tooltip}</p> : null}
      {children}
    </label>
  );
}

export function TextInput(props) {
  return <Input {...props} />;
}

export function TextArea({ className, ...props }) {
  return (
    <textarea
      className={cn(
        'flex w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

export function SelectInput({ options, ...props }) {
  return <Select options={options} {...props} />;
}

export function RadioPair({ value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {['Yes', 'No'].map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          className={cn(
            'rounded-md border px-3 py-2 text-sm font-medium transition',
            value === option
              ? 'border-primary bg-primary/10 text-secondary'
              : 'border-gray-300 text-gray-600 hover:border-gray-400',
          )}
        >
          {option}
        </button>
      ))}
    </div>
  );
}

export function ButtonGroup({ options, value, onChange }) {
  const cols = options.length === 2 ? 'grid-cols-2' : 'grid-cols-3';
  return (
    <div className={`grid ${cols} gap-2`}>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          className={cn(
            'rounded-md border px-3 py-2 text-sm transition',
            value === option
              ? 'border-primary bg-primary/10 text-secondary'
              : 'border-gray-300 text-gray-600',
          )}
        >
          {option}
        </button>
      ))}
    </div>
  );
}

export function TogglePill({ enabled, onToggle, enabledLabel = 'Enabled', disabledLabel = 'Disabled' }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'rounded-full px-4 py-2 text-sm font-semibold transition',
        enabled ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700',
      )}
    >
      {enabled ? enabledLabel : disabledLabel}
    </button>
  );
}
